import React from "react";
import PredictionsCarousel from "components/carousel/PredictionsCarousel";

const PredictionsContainer = ({ updatedPredictions }) => {
  return (
    <div className="w-full my-2 md:my-4 overflow-hidden">
      <PredictionsCarousel slides={updatedPredictions} />
    </div>
  );
};

export default PredictionsContainer;
